<template>
  <nav class="navbar">
    <div class="container">
      <ul class="nav-links">
        <li class="logo-item">
          <div class="logo">
            <img src="@/assets/logo2.png" alt="QINYUAN GROUP Brand Logo Chemical Enterprise" />
          </div>
        </li>
        <li>
          <router-link to="/" exact class="nav-link" active-class="active-link">
            HOME&nbsp;&nbsp;首页
          </router-link>
        </li>
        <li>
          <router-link to="/about" class="nav-link" active-class="active-link">
            ABOUT US&nbsp;&nbsp;关于我们
          </router-link>
        </li>
        <li>
          <router-link to="/products" class="nav-link" active-class="active-link">
            PRODUCTS&nbsp;&nbsp;产品
          </router-link>
        </li>
        <li>
          <router-link to="/events" class="nav-link" active-class="active-link">
            EVENTS&nbsp;&nbsp;活动
          </router-link>
        </li>
        <li>
          <router-link to="/contactus" class="nav-link" active-class="active-link">
            CONTACT US&nbsp;&nbsp;联系我们
          </router-link>
        </li>
        <li>
          <router-link to="/login" class="nav-link" active-class="active-link">
            LOG IN&nbsp;&nbsp;登录
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {};
</script>

<style scoped>
.container {
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 40px;
  box-sizing: border-box;
}
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 90px;
  background: #ffffff;
  z-index: 9999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.navbar .container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
}
.logo-item {
  padding: 10px 24px;
  border-bottom: 4px solid transparent !important;
}
.logo-item:hover {
  border-bottom: 4px solid transparent !important;
}
.navbar .logo img {
  height: 40px;
  margin-top: -10px;
}
.navbar .nav-links {
  font-size: 15px;
  font-weight: 500;
  color: #333;
  box-sizing: border-box;
   margin-top: 30px;
}
.navbar .nav-links li {
  float: left;
  padding: 10px 24px;
  border-bottom: 4px solid transparent;
}
.navbar .nav-links li:hover {
  border-bottom: 4px solid #e02020;
}
.navbar .nav-links a:hover {
  color: #e02020;
}
.active-link {
  color: #e02020;
  border-bottom: 4px solid transparent;
}

/* 新增移动端适配 原有样式全部保留不变 */
@media screen and (max-width: 1200px) {
  .navbar {
    height: 75px;
  }
  .navbar .nav-links li {
    padding: 10px 16px;
  }
}
@media screen and (max-width: 768px) {
  .navbar {
    height: auto;
    padding: 10px 0;
  }
  .navbar .container {
    justify-content: center;
  }
  .navbar .nav-links {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .navbar .nav-links li {
    float: none;
    padding: 8px 12px;
  }
  .navbar .logo img {
    height: 32px;
  }
  .container {
    padding: 0 15px;
  }
}
</style>